module.exports = __webpack_public_path__ + "img/memorabilia-banner.50ed8239.jpg";